import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import CssBaseline from '@mui/material/CssBaseline';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { ThemeController } from './components/ThemeController';
import { I18nProvider } from './i18n';
import { queryClient } from './queryClient';
import { ROUTER_BASENAME, router } from './router';

// B18 i18n: ensure the URL lives under the locale prefix (`/en`). A bare or
// non-prefixed entry path is rewritten before the router boots (Apache also
// 301s `/`→`/en/` in prod). Keeps every internal link working unchanged.
if (!location.pathname.startsWith(`${ROUTER_BASENAME}/`) && location.pathname !== ROUTER_BASENAME) {
  const rest = location.pathname === '/' ? '' : location.pathname;
  history.replaceState(null, '', ROUTER_BASENAME + rest + location.search + location.hash);
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <ThemeController>
      <CssBaseline />
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </I18nProvider>
    </ThemeController>
  </StrictMode>,
);
